import {REG} from "/@lib@/commons/registry.js";

/**
 * Stylage racine d'un éditeur.
 * Permet de définir les styles transversaux à tous les binds.
 */

REG.reg.registerSkin('styler-inputs', 1, /* language=CSS */ `
	:host([wed-name="addFile#dstPath"]) {
		flex: 1;
		overflow: hidden;
	}
`);

/*
REG.reg.registerSkin('box/head-body', 10, `
	:host{
		border: 5px solid green;
	}
`);
*/